export default "__VITE_ASSET__CyQ_ZJ7K__"